import request from '@/utils/request'
import store from '@/store'

const url = store.getters.getPostUrl;
export default {
  getDeviceAll(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/base/device/all',
      method: 'get'
    })
  },
  getDeviceOverview(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/device/overview',
      method: 'post',
      data:param
    })
  },
  getDeviceOverviewOne(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/device/overview/one',
      method: 'post',
      data:param
    })
  },
  getReportDay(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/report/day',
      method: 'post',
      data:param
    })
  },
  getReportMonth(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/report/month',
      method: 'post',
      data:param
    })
  },
  getDeviceAllList(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/device/all',
      method: 'post',
      data:param
    })
  },
  getReportDayOne(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/report/day/one',
      method: 'post',
      data:param
    })
  },
  getReportMonthOne(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/report/month/one',
      method: 'post',
      data:param
    })
  },
  Login(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/login',
      method: 'post',
      data:param
    })
  },
  LoginOut(param) {
    return request({
      url: store.getters.getPostUrl + 'mes/logout',
      method: 'post'
    })
  },
  changePassword(id,param) {
    return request({
      url: store.getters.getPostUrl + '/mes/user/password/' + id,
      method: 'put',
      params:param
    })
  },
	getColors() {
	  return request({
	    url: store.getters.getPostUrl + 'mes/signal/selectSignalColor',
	    method: 'get'
	  })
	},
}



// WEBPACK FOOTER //
// ./src/assets/js/request/request.js